import { createConfirmation } from 'react-confirm'
import ConfirmDialog from './ConfirmDialog'

// create confirm function
const confirm = createConfirmation(ConfirmDialog)

export default function(confirmation, options = {}) {
    return confirm({ confirmation, options })
}
